import api from './api';
import './App.css';
import { Login } from './Login/Login.jsx';
import React, { useEffect, useState } from 'react';
import MainApp from './MainApp';
import { ThemeProvider } from '@emotion/react';
import { darkTheme, lightTheme } from './styles/theme';
import { setTheme } from "./rtk/theme";


import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './rtk/store';
import { Button, CircularProgress, Container, CssBaseline, Paper, Typography, responsiveFontSizes } from '@mui/material';
import AuthenticationApp from './Login/AuthenticationApp';
import { setUser } from './rtk/userSlice';
import { rtkapi } from './rtk/rtkapi.js';
import NoAccessPage from './NoAccessPage.jsx';

import { useTranslation } from 'react-i18next';

const App = (props) => {
  let [isConnected, setIsConnected] = useState(null)
  let [isLoading, setIsLoading] = useState(true)

  let [currentTheme, setCurrentTheme] = useState(darkTheme)
  const themeColor = useSelector((state) => state.theme.theme);

  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    api.getCsrfToken();
  }, [])
  
  useEffect(() => {
    verifyAuth()
  }, [])

  useEffect(() => {
    const navigatorlang = navigator.language.split('-')[0] || 'fr'
    if (user?.preffered_language) {
      localStorage.setItem('lang', user.preffered_language)
      i18n.changeLanguage(user.preffered_language)
    }
    else if (localStorage.getItem('lang') === null) {
      localStorage.setItem('lang', navigatorlang)
    }
    else {
      i18n.changeLanguage(localStorage.getItem('lang'))
    }
  }, [user])

  useEffect(() => {
    const localStorageTheme = localStorage.getItem('darkMode')
    console.log(localStorageTheme)
    if (localStorageTheme === null) {
      localStorage.setItem('darkMode', true)
      dispatch(setTheme("dark"))
    }
    else {
      localStorage.getItem('darkMode') === 'false' ? dispatch(setTheme("light")) : dispatch(setTheme("dark")) 
    }
  }, [])

  useEffect(() => {
    if (!themeColor) {
      // setCurrentTheme(darkTheme)
    }
    if (themeColor === "light") {
      setCurrentTheme(lightTheme)
    }
    else {
      setCurrentTheme(darkTheme)
    }
  }, [themeColor])

  useEffect(() => {
    if (isConnected) {
      getUser()
    }
    else if (isConnected !== null) {
      setIsLoading(false)
    }
  }, [isConnected])



  const logoff = () => {
    dispatch(rtkapi.util.resetApiState())
    dispatch(setUser(null))
    localStorage.clear()
    store.dispatch(store => store = undefined)
    setIsConnected(false)

    // remove cache in redux
  }


  const verifyAuth = async () => {
    let res = await api.verifyToken()

    if (res.status === 200) {
      setIsConnected(true)
      return
    }
    setIsConnected(false)

  }

  const getUser = async () => {
    let res = await api.get('/me/')
    if (res.status === 200) {
      dispatch(setUser(res.data))
    }
    else {
      dispatch(setUser(null))
    }
    setIsLoading(false)
  }

  const changeScope = async (scopeId) => {
    await api.post('/me/change-scope/', { 'scope': scopeId })
    dispatch(rtkapi.util.resetApiState())
    getUser()
    window.location.replace("/")
  }

  let theme2 = responsiveFontSizes(currentTheme)


  if (isLoading) {
    return (
      <ThemeProvider theme={theme2}>
        <Container sx={{ height: "80%", justifyContent: "center", alignItems: "center", display: "flex" }}>
          <CircularProgress size={100} />
        </Container>
      </ThemeProvider>
    )
  }


  if (isConnected && user) {
    return (
      <ThemeProvider theme={theme2}>
        <CssBaseline />
        <MainApp logoff={logoff} changeScope={changeScope} />
      </ThemeProvider>
    )
  }


  return (
    <ThemeProvider theme={theme2}>
      <CssBaseline />
      <AuthenticationApp verifyAuth={verifyAuth} ></AuthenticationApp>
    </ThemeProvider>
  )
}

export default App;
